/* eslint-disable react/prop-types */
import React from 'react';
import { CodeBlock } from '@atlaskit/code';
import {
    getCodeLanguage,
    type GqlComponentCodeBlock
} from '../../../../content/types/content/component-code-block';

interface ComponentCodeBlockProps {
    entry: GqlComponentCodeBlock;
}

const ComponentCodeBlock: React.FC<ComponentCodeBlockProps> = ({ entry }) => {
    const { code, language, title } = entry;

    return (
        <>
            {title && (
                <p data-testid="component-code-block-title">
                    <strong>{title}</strong>
                </p>
            )}
            <div className="kb-article-code-block">
                <CodeBlock text={code} language={getCodeLanguage(language)} />
            </div>
        </>
    );
};

export default ComponentCodeBlock;
